// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicOrderStateControllerGetAllData } from './PublicOrderStateControllerGetAllData.gen';
import type { PublicOrderStateControllerGetAllErrors } from './PublicOrderStateControllerGetAllErrors.gen';
import type { PublicOrderStateControllerGetAllResponses } from './PublicOrderStateControllerGetAllResponses.gen';

export class PublicOrderStateController {
    /**
     * Get order possible states
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicOrderStateControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicOrderStateControllerGetAllResponses, PublicOrderStateControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/order-states',
            ...options
        });
    }
}
